import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
    AdminGetUser
} from "../../../../Common/lib/Admin/AdminAPI";
import EditUser from "./editUser";

/**
 * Returns the Edit User Page component.
 * 
 * @returns The Edit User Page component.
 */
const EditUserPage = () => {
    let username = useLocation();
    const [cognitoUser, setCognitoUser] = useState([]);
    const [userUpdate, setUserUpdate] = useState(false);

    const getUser = async () => {
        try {
            const userId = username.state.userId || username.state.username;
            const res = await AdminGetUser(userId);
            setCognitoUser(res);
        } catch (error) {
            // console.log(error);
        }
    };

    useEffect(() => {
        getUser();
    }, []);

    return (
        <>
            <div className="flex flex-col h-fit md:h-screen">
                <div className="h-full bg-gray-50">

                    {cognitoUser && cognitoUser.Username && (
                        <EditUser
                            user={cognitoUser}
                            contributorAccess={username.state.contributorAccess || false}
                            setUserUpdate={setUserUpdate}
                        />
                    )}
                </div>

            </div>
        </>
    );
};

export default EditUserPage;